import { fromJS } from 'immutable';
import { DISMISS_GBQ_BANNER, GRADE_BY_QUESTION_ENABLED, GBQ_SET_ACTIVE_ITEM } from '@instructure/quiz-common';
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fromJS({});
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case GRADE_BY_QUESTION_ENABLED:
      return state.set('gradeByQuestionEnabled', action.payload);
    case GBQ_SET_ACTIVE_ITEM:
      return state.set('activeItemId', action.payload);
    case DISMISS_GBQ_BANNER:
      return state.set('gradeByQuestionBannerDismissed', true);
    default:
      return state;
  }
});